import React from 'react';
export function Guarantee() {
  return <section className="bg-gray-100 py-12 md:py-16 px-4" data-id="element-84">
      <div className="max-w-xl mx-auto" data-id="element-85">
        <div className="bg-white rounded-xl p-8 shadow-lg" data-id="element-86">
          <div className="text-6xl text-center mb-4" data-id="element-87">🛡️</div>

          <h2 className="text-2xl font-bold text-carbon text-center mb-6" data-id="element-88">
            GARANTÍA CIENCIAS 360 — 7 DÍAS
          </h2>

          <ol className="space-y-2 mb-6 text-center text-gray-700" data-id="element-89">
            <li data-id="element-90">1. Abrís los 12 tomos.</li>
            <li data-id="element-91">2. Revisás los 6 bonus.</li>
            <li data-id="element-92">3. Los usás en el aula si querés.</li>
          </ol>

          <div className="border-t border-gray-200 my-6" data-id="element-93"></div>

          <p className="font-bold text-carbon text-center mb-4" data-id="element-94">
            Si en 7 días no es lo que esperabas:
          </p>

          <div className="space-y-2 mb-6" data-id="element-95">
            <div className="flex gap-2 items-center justify-center" data-id="element-96">
              <span className="text-bio-green" data-id="element-97">✅</span>
              <span className="text-gray-700" data-id="element-98">Te devolvemos el 100%.</span>
            </div>
            <div className="flex gap-2 items-center justify-center" data-id="element-99">
              <span className="text-bio-green" data-id="element-100">✅</span>
              <span className="text-gray-700" data-id="element-101">Sin preguntas.</span>
            </div>
            <div className="flex gap-2 items-center justify-center" data-id="element-102">
              <span className="text-bio-green" data-id="element-103">✅</span>
              <span className="text-gray-700" data-id="element-104">Sin formularios. Sin drama.</span>
            </div>
          </div>

          <p className="text-sm text-gray-600 text-center italic" data-id="element-105">
            La confianza que tenemos en Ciencias 360
            <br data-id="element-106" />
            nos permite ofrecerte eso.
            <br data-id="element-107" />
            Más de 800 docentes ya lo saben.
          </p>
        </div>
      </div>
    </section>;
}